/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require("google-protobuf");
var goog = jspb;
var global = Function("return this")();

var Request_pb = require("./Request_pb.js");
var Response_pb = require("./Response_pb.js");
var Global_pb = require("./Global_pb.js");
goog.exportSymbol("proto.proto.UserLogin", null, global);
goog.exportSymbol("proto.proto.UserLoginResponse", null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.UserLogin = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.UserLogin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.UserLogin.displayName = "proto.proto.UserLogin";
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.UserLogin.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.UserLogin.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.UserLogin} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.UserLogin.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        request: (f = msg.getRequest()) && Request_pb.Request.toObject(includeInstance, f),
        token: jspb.Message.getFieldWithDefault(msg, 2, ""),
        appName: jspb.Message.getFieldWithDefault(msg, 3, ""),
        appId: jspb.Message.getFieldWithDefault(msg, 4, 0),
        appBuildVersion: jspb.Message.getFieldWithDefault(msg, 5, 0),
        appVersion: jspb.Message.getFieldWithDefault(msg, 6, ""),
        platform: jspb.Message.getFieldWithDefault(msg, 7, 0),
        platformVersion: jspb.Message.getFieldWithDefault(msg, 8, ""),
        device: jspb.Message.getFieldWithDefault(msg, 9, 0),
        deviceName: jspb.Message.getFieldWithDefault(msg, 10, ""),
        language: jspb.Message.getFieldWithDefault(msg, 11, 0),
        symmetricKey: msg.getSymmetricKey_asB64(),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.UserLogin}
 */
proto.proto.UserLogin.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.UserLogin();
  return proto.proto.UserLogin.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.UserLogin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.UserLogin}
 */
proto.proto.UserLogin.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new Request_pb.Request();
        reader.readMessage(value, Request_pb.Request.deserializeBinaryFromReader);
        msg.setRequest(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setToken(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setAppName(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setAppId(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setAppBuildVersion(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setAppVersion(value);
        break;
      case 7:
        var value = /** @type {!proto.proto.Platform} */ (reader.readEnum());
        msg.setPlatform(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setPlatformVersion(value);
        break;
      case 9:
        var value = /** @type {!proto.proto.Device} */ (reader.readEnum());
        msg.setDevice(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setDeviceName(value);
        break;
      case 11:
        var value = /** @type {!proto.proto.Language} */ (reader.readEnum());
        msg.setLanguage(value);
        break;
      case 12:
        var value = /** @type {!Uint8Array} */ (reader.readBytes());
        msg.setSymmetricKey(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.UserLogin.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.UserLogin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.UserLogin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.UserLogin.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(1, f, Request_pb.Request.serializeBinaryToWriter);
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getAppName();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getAppId();
  if (f !== 0) {
    writer.writeUint32(4, f);
  }
  f = message.getAppBuildVersion();
  if (f !== 0) {
    writer.writeUint32(5, f);
  }
  f = message.getAppVersion();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getPlatform();
  if (f !== 0.0) {
    writer.writeEnum(7, f);
  }
  f = message.getPlatformVersion();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getDevice();
  if (f !== 0.0) {
    writer.writeEnum(9, f);
  }
  f = message.getDeviceName();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(11, f);
  }
  f = message.getSymmetricKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(12, f);
  }
};

/**
 * optional Request request = 1;
 * @return {?proto.proto.Request}
 */
proto.proto.UserLogin.prototype.getRequest = function () {
  return /** @type{?proto.proto.Request} */ (jspb.Message.getWrapperField(this, Request_pb.Request, 1));
};

/** @param {?proto.proto.Request|undefined} value */
proto.proto.UserLogin.prototype.setRequest = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.proto.UserLogin.prototype.clearRequest = function () {
  this.setRequest(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.UserLogin.prototype.hasRequest = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional string token = 2;
 * @return {string}
 */
proto.proto.UserLogin.prototype.getToken = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};

/** @param {string} value */
proto.proto.UserLogin.prototype.setToken = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string app_name = 3;
 * @return {string}
 */
proto.proto.UserLogin.prototype.getAppName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};

/** @param {string} value */
proto.proto.UserLogin.prototype.setAppName = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional uint32 app_id = 4;
 * @return {number}
 */
proto.proto.UserLogin.prototype.getAppId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/** @param {number} value */
proto.proto.UserLogin.prototype.setAppId = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional uint32 app_build_version = 5;
 * @return {number}
 */
proto.proto.UserLogin.prototype.getAppBuildVersion = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.proto.UserLogin.prototype.setAppBuildVersion = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string app_version = 6;
 * @return {string}
 */
proto.proto.UserLogin.prototype.getAppVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};

/** @param {string} value */
proto.proto.UserLogin.prototype.setAppVersion = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional Platform platform = 7;
 * @return {!proto.proto.Platform}
 */
proto.proto.UserLogin.prototype.getPlatform = function () {
  return /** @type {!proto.proto.Platform} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};

/** @param {!proto.proto.Platform} value */
proto.proto.UserLogin.prototype.setPlatform = function (value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};

/**
 * optional string platform_version = 8;
 * @return {string}
 */
proto.proto.UserLogin.prototype.getPlatformVersion = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};

/** @param {string} value */
proto.proto.UserLogin.prototype.setPlatformVersion = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional Device device = 9;
 * @return {!proto.proto.Device}
 */
proto.proto.UserLogin.prototype.getDevice = function () {
  return /** @type {!proto.proto.Device} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};

/** @param {!proto.proto.Device} value */
proto.proto.UserLogin.prototype.setDevice = function (value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};

/**
 * optional string device_name = 10;
 * @return {string}
 */
proto.proto.UserLogin.prototype.getDeviceName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};

/** @param {string} value */
proto.proto.UserLogin.prototype.setDeviceName = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional Language language = 11;
 * @return {!proto.proto.Language}
 */
proto.proto.UserLogin.prototype.getLanguage = function () {
  return /** @type {!proto.proto.Language} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};

/** @param {!proto.proto.Language} value */
proto.proto.UserLogin.prototype.setLanguage = function (value) {
  jspb.Message.setProto3EnumField(this, 11, value);
};

/**
 * optional bytes symmetric_key = 12;
 * @return {!(string|Uint8Array)}
 */
proto.proto.UserLogin.prototype.getSymmetricKey = function () {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};

/**
 * optional bytes symmetric_key = 12;
 * This is a type-conversion wrapper around `getSymmetricKey()`
 * @return {string}
 */
proto.proto.UserLogin.prototype.getSymmetricKey_asB64 = function () {
  return /** @type {string} */ (jspb.Message.bytesAsB64(this.getSymmetricKey()));
};

/**
 * optional bytes symmetric_key = 12;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSymmetricKey()`
 * @return {!Uint8Array}
 */
proto.proto.UserLogin.prototype.getSymmetricKey_asU8 = function () {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(this.getSymmetricKey()));
};

/** @param {!(string|Uint8Array)} value */
proto.proto.UserLogin.prototype.setSymmetricKey = function (value) {
  jspb.Message.setProto3BytesField(this, 12, value);
};

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.UserLoginResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.UserLoginResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proto.UserLoginResponse.displayName = "proto.proto.UserLoginResponse";
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.proto.UserLoginResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.proto.UserLoginResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.proto.UserLoginResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.proto.UserLoginResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        response: (f = msg.getResponse()) && Response_pb.Response.toObject(includeInstance, f),
        deprecatedClient: jspb.Message.getFieldWithDefault(msg, 2, false),
        secondaryNodeName: jspb.Message.getFieldWithDefault(msg, 3, ""),
        updateAvailable: jspb.Message.getFieldWithDefault(msg, 4, false),
        chatDeleteMessageForBothPeriod: jspb.Message.getFieldWithDefault(msg, 5, 0),
        walletActive: jspb.Message.getFieldWithDefault(msg, 6, false),
        mplActive: jspb.Message.getFieldWithDefault(msg, 7, false),
        walletAgreementAccepted: jspb.Message.getFieldWithDefault(msg, 8, false),
        accessToken: jspb.Message.getFieldWithDefault(msg, 9, ""),
        contactHash: jspb.Message.getFieldWithDefault(msg, 10, ""),
        role: jspb.Message.getFieldWithDefault(msg, 11, 0),
        needFcmToken: jspb.Message.getFieldWithDefault(msg, 12, false),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.UserLoginResponse}
 */
proto.proto.UserLoginResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.UserLoginResponse();
  return proto.proto.UserLoginResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.UserLoginResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.UserLoginResponse}
 */
proto.proto.UserLoginResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new Response_pb.Response();
        reader.readMessage(value, Response_pb.Response.deserializeBinaryFromReader);
        msg.setResponse(value);
        break;
      case 2:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setDeprecatedClient(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setSecondaryNodeName(value);
        break;
      case 4:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setUpdateAvailable(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setChatDeleteMessageForBothPeriod(value);
        break;
      case 6:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setWalletActive(value);
        break;
      case 7:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setMplActive(value);
        break;
      case 8:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setWalletAgreementAccepted(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccessToken(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setContactHash(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setRole(value);
        break;
      case 12:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setNeedFcmToken(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.UserLoginResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.proto.UserLoginResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.UserLoginResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.UserLoginResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(1, f, Response_pb.Response.serializeBinaryToWriter);
  }
  f = message.getDeprecatedClient();
  if (f) {
    writer.writeBool(2, f);
  }
  f = message.getSecondaryNodeName();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getUpdateAvailable();
  if (f) {
    writer.writeBool(4, f);
  }
  f = message.getChatDeleteMessageForBothPeriod();
  if (f !== 0) {
    writer.writeUint32(5, f);
  }
  f = message.getWalletActive();
  if (f) {
    writer.writeBool(6, f);
  }
  f = message.getMplActive();
  if (f) {
    writer.writeBool(7, f);
  }
  f = message.getWalletAgreementAccepted();
  if (f) {
    writer.writeBool(8, f);
  }
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getContactHash();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getRole();
  if (f !== 0) {
    writer.writeInt32(11, f);
  }
  f = message.getNeedFcmToken();
  if (f) {
    writer.writeBool(12, f);
  }
};

/**
 * optional Response response = 1;
 * @return {?proto.proto.Response}
 */
proto.proto.UserLoginResponse.prototype.getResponse = function () {
  return /** @type{?proto.proto.Response} */ (jspb.Message.getWrapperField(this, Response_pb.Response, 1));
};

/** @param {?proto.proto.Response|undefined} value */
proto.proto.UserLoginResponse.prototype.setResponse = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.proto.UserLoginResponse.prototype.clearResponse = function () {
  this.setResponse(undefined);
};

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proto.UserLoginResponse.prototype.hasResponse = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional bool deprecated_client = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.UserLoginResponse.prototype.getDeprecatedClient = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};

/** @param {boolean} value */
proto.proto.UserLoginResponse.prototype.setDeprecatedClient = function (value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};

/**
 * optional string secondary_node_name = 3;
 * @return {string}
 */
proto.proto.UserLoginResponse.prototype.getSecondaryNodeName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};

/** @param {string} value */
proto.proto.UserLoginResponse.prototype.setSecondaryNodeName = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional bool update_available = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.UserLoginResponse.prototype.getUpdateAvailable = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};

/** @param {boolean} value */
proto.proto.UserLoginResponse.prototype.setUpdateAvailable = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};

/**
 * optional uint32 chat_delete_message_for_both_period = 5;
 * @return {number}
 */
proto.proto.UserLoginResponse.prototype.getChatDeleteMessageForBothPeriod = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/** @param {number} value */
proto.proto.UserLoginResponse.prototype.setChatDeleteMessageForBothPeriod = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional bool wallet_active = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.UserLoginResponse.prototype.getWalletActive = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};

/** @param {boolean} value */
proto.proto.UserLoginResponse.prototype.setWalletActive = function (value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};

/**
 * optional bool mpl_active = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.UserLoginResponse.prototype.getMplActive = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 7, false));
};

/** @param {boolean} value */
proto.proto.UserLoginResponse.prototype.setMplActive = function (value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};

/**
 * optional bool wallet_agreement_accepted = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.UserLoginResponse.prototype.getWalletAgreementAccepted = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};

/** @param {boolean} value */
proto.proto.UserLoginResponse.prototype.setWalletAgreementAccepted = function (value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};

/**
 * optional string access_token = 9;
 * @return {string}
 */
proto.proto.UserLoginResponse.prototype.getAccessToken = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};

/** @param {string} value */
proto.proto.UserLoginResponse.prototype.setAccessToken = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string contact_hash = 10;
 * @return {string}
 */
proto.proto.UserLoginResponse.prototype.getContactHash = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};

/** @param {string} value */
proto.proto.UserLoginResponse.prototype.setContactHash = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional int32 role = 11;
 * @return {number}
 */
proto.proto.UserLoginResponse.prototype.getRole = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};

/** @param {number} value */
proto.proto.UserLoginResponse.prototype.setRole = function (value) {
  jspb.Message.setProto3IntField(this, 11, value);
};

/**
 * optional bool need_fcm_token = 12;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proto.UserLoginResponse.prototype.getNeedFcmToken = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 12, false));
};

/** @param {boolean} value */
proto.proto.UserLoginResponse.prototype.setNeedFcmToken = function (value) {
  jspb.Message.setProto3BooleanField(this, 12, value);
};

goog.object.extend(exports, proto.proto);
